import { __decorate, __extends } from "tslib";
import { CustomElement, element, prop } from '@wk/custom-element';
import isServer from 'detect-node';
import { throttle } from '../safeRafThrottle';
export var WK_SCROLL_FADE_TOP_ClASS = 'wk-scroll-fade-top';
export var WK_SCROLL_FADE_BOTTOM_ClASS = 'wk-scroll-fade-bottom';
var ScrollFadeComponent = (function (_super) {
    __extends(ScrollFadeComponent, _super);
    function ScrollFadeComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isScrollingCallback = null;
        _this.onScroll = throttle(function () {
            if (_this.targetElement) {
                _this.setStyles();
            }
        });
        return _this;
    }
    ScrollFadeComponent.prototype.disconnectedCallback = function () {
        if (this.targetElement) {
            this.targetElement.removeEventListener('scroll', this.onScroll);
            this.clearStyles(this.targetElement);
        }
    };
    ScrollFadeComponent.prototype.propsChangedCallback = function (propName, oldValue) {
        if (propName === 'targetElement' && this.targetElement) {
            if (oldValue) {
                oldValue.removeEventListener('scroll', this.onScroll);
                this.clearStyles(oldValue);
            }
            this.targetElement.addEventListener('scroll', this.onScroll);
            this.setStyles();
        }
    };
    ScrollFadeComponent.prototype.setStyles = function () {
        if (!isServer) {
            var _a = this.targetElement, scrollTop = _a.scrollTop, clientHeight = _a.clientHeight, scrollHeight = _a.scrollHeight, classList = _a.classList;
            if (this.isEqual(scrollHeight, clientHeight)) {
                this.clearStyles(this.targetElement);
                this.isScrollingCallback && this.isScrollingCallback(false);
            }
            else if (this.isEqual(scrollTop, 0)) {
                classList.remove(WK_SCROLL_FADE_TOP_ClASS);
                classList.add(WK_SCROLL_FADE_BOTTOM_ClASS);
                this.isScrollingCallback &&
                    this.isScrollingCallback(true, 'bottom');
            }
            else if (this.isEqual(scrollTop + clientHeight, scrollHeight)) {
                classList.remove(WK_SCROLL_FADE_BOTTOM_ClASS);
                classList.add(WK_SCROLL_FADE_TOP_ClASS);
                this.isScrollingCallback &&
                    this.isScrollingCallback(true, 'top');
            }
            else {
                classList.add(WK_SCROLL_FADE_BOTTOM_ClASS);
                classList.add(WK_SCROLL_FADE_TOP_ClASS);
                this.isScrollingCallback && this.isScrollingCallback(true);
            }
        }
    };
    ScrollFadeComponent.prototype.clearStyles = function (targetEl) {
        if (!isServer) {
            var classList = targetEl.classList;
            classList.remove(WK_SCROLL_FADE_TOP_ClASS);
            classList.remove(WK_SCROLL_FADE_BOTTOM_ClASS);
        }
    };
    ScrollFadeComponent.prototype.isEqual = function (a, b, e) {
        if (e === void 0) { e = 1; }
        return Math.abs(a - b) < e;
    };
    __decorate([
        prop()
    ], ScrollFadeComponent.prototype, "targetElement", void 0);
    __decorate([
        prop()
    ], ScrollFadeComponent.prototype, "isScrollingCallback", void 0);
    ScrollFadeComponent = __decorate([
        element('wk-scroll-fade')
    ], ScrollFadeComponent);
    return ScrollFadeComponent;
}(CustomElement));
export { ScrollFadeComponent };
